import styled from "styled-components";

export const UserMenuItemsTitleBox = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  margin: 0;
  padding: 2rem;
  font-size: 1.6rem;
  color: ${props => props.theme.colors.textLight};

  &:before {
    content: "";
    width: 3rem;
    height: 3rem;
    margin: 0 4rem 0 0;
    background-image: url("${props => props.theme.images.spriteSheet.toString()}");
    background-position: -250px -356px;

    .cgp-rtl & {
      margin: 0 0 0 2rem;
    }

    .club888 & {
      background-position: -191px -418px;
    }
  }

  &:after {
    content: "";
    width: 15px;
    height: 15px;
    margin: 0 0 0 auto;
    background-image: url("${props => props.theme.images.spriteSheet.toString()}");
    background-position: -746px -654px;;

    .cgp-rtl & {
      margin: 0 auto 0 0;
      transform: scaleX(-1);
    }
  }

`